import { Select } from "antd";

const SingleMultiSelect = ({
  name,
  mode,
  value,
  options,
  onChange,
  placeholder,
}) => {
  const handleChange = (val) => {
    onChange({ name, value: val });
  };

  return (
    <Select
    allowClear
      size="large"
      name={name}
      mode={mode}
      value={value}
      style={{ width: "100%" }}
      options={options}  
      onChange={(e) => handleChange(e)}
      placeholder={placeholder}
      optionRender={(option)=>option.label}
      getPopupContainer={(trigger) => trigger.parentElement}
    />
  );
};

export default SingleMultiSelect;
